import {getStoryBySlug} from "../story/requests";
import {Author} from "./entities";
import {authorSlugFromPath} from "../../helpers/URLHelpers";

const getAuthorBySlug = path =>
  getStoryBySlug(authorSlugFromPath(path)).then(Author)

export {getAuthorBySlug}
